<template>
  <el-tiptap
    v-model="modelContent"
    :extensions="extensionTitle"
    :charCounterCount="false"
    class="mt-4 custom-border-tiptap"
  />
</template>

<script>
import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Underline,
  Italic,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
  TextAlign,
  Indent,
  FontType,
  FontSize,
  LineHeight,
  TextColor,
  TextHighlight,
  HardBreak,
  History,
} from 'element-tiptap';

export default {
  name: "WarrantyTitleEditor",

  props: {
    content: {
      type: String,
      default: '',
    }
  },

  data () {
    return {
      extensionTitle: [
        new Doc(),
        new Text(),
        new Paragraph(),
        new Heading({ level: 5 }),
        new Bold(),
        new Underline(),
        new Italic(),
        new Strike(),
        new ListItem(),
        new BulletList(),
        new OrderedList(),
        new TextAlign({
          alignments: ['left', 'center', 'right', 'justify'],
        }),
        new Indent(),
        new FontType(),
        new FontSize(),
        new LineHeight({
          lineHeights: ['75%','80%', '90%', '100%', '150%', '200%']
        }),
        new TextColor(),
        new TextHighlight(),
        new HardBreak(),
        new History(),
      ],
    };
  },

  computed: {
    modelContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.$emit('update:title', value)
      }
    }
  }
}
</script>
